// Small data indicators: avatar, battery bar, signal bars. Ported from
// botriq-admin-fe's Robot Portal UI kit.
import PropTypes from "prop-types";
import Icon from "./Icon";

export const battColor = (b) => {
  if (b > 60) return "var(--bq-success)";
  if (b >= 25) return "var(--bq-warning)";
  return "var(--bq-danger)";
};

export const Avatar = ({ code = "?", size = 26, color }) => {
  const c0 = code.charCodeAt(0) || 63;
  const c1 = code.charCodeAt(1) || 0;
  const hue = (c0 * 37 + c1 * 11) % 360;
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: 7,
        flex: "none",
        display: "grid",
        placeItems: "center",
        fontSize: size * 0.42,
        fontWeight: 600,
        color: "#fff",
        background: color || `hsl(${hue} 55% 42%)`,
        letterSpacing: "-.02em",
      }}
    >
      {code.slice(0, 2).toUpperCase()}
    </div>
  );
};

Avatar.propTypes = { code: PropTypes.string, size: PropTypes.number, color: PropTypes.string };

export const BatteryBar = ({ value = 0, width = 48, charging = false }) => {
  const displayValue = Math.round(value * 100) / 100;
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
      <div
        style={{
          width,
          height: 5,
          borderRadius: 3,
          background: "var(--bq-surface3)",
          overflow: "hidden",
          flex: "none",
        }}
      >
        <div
          style={{
            width: `${displayValue}%`,
            height: "100%",
            borderRadius: 3,
            background: battColor(displayValue),
          }}
        />
      </div>
      <span
        style={{
          fontSize: 12,
          fontWeight: 600,
          color: "var(--bq-text2)",
          fontVariantNumeric: "tabular-nums",
          minWidth: 30,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        {displayValue}%
        {charging && <Icon name="zap" size={12} color="var(--bq-warning)" titleAccess="Charging" />}
      </span>
    </div>
  );
};

BatteryBar.propTypes = {
  value: PropTypes.number,
  width: PropTypes.number,
  charging: PropTypes.bool,
};

const barColor = (index, active, signal) => {
  if (index >= active) return "var(--bq-surface3)";
  return signal >= 50 ? "var(--bq-success)" : "var(--bq-warning)";
};

export const SignalBars = ({ signal = 0 }) => {
  const bars = [25, 50, 75, 100];
  const active = signal === 0 ? 0 : Math.ceil(signal / 25);
  return (
    <div style={{ display: "flex", alignItems: "flex-end", gap: 2, height: 14 }}>
      {bars.map((b, i) => (
        <span
          key={b}
          style={{
            width: 3,
            height: 4 + i * 3,
            borderRadius: 1,
            background: barColor(i, active, signal),
          }}
        />
      ))}
    </div>
  );
};

SignalBars.propTypes = { signal: PropTypes.number };

export default Avatar;
